import React, { useEffect, useMemo, useState } from "react";
import { Box, Typography } from "@mui/material";
import DCCostBatchDetail from "./DCCostBatchDetail";
import { getEscalatedSkuStatusRows } from "../../API/dcSkuStatusApi";

const DCEscalationReviews = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const batchIdOverride = useMemo(() => {
    const batchIds = Array.from(
      new Set(rows.map((row) => row?.batchId ?? row?.batchID ?? row?.batch_id ?? row?.batchid).filter(Boolean))
    );

    return batchIds.length === 1 ? batchIds[0] : null;
  }, [rows]);

  useEffect(() => {
    let isCancelled = false;

    const loadRows = async () => {
      setLoading(true);

      try {
        const escalatedSkuRows = await getEscalatedSkuStatusRows();

        if (!isCancelled) {
          setRows(Array.isArray(escalatedSkuRows) ? escalatedSkuRows : []);
        }
      } catch {
        if (!isCancelled) {
          setRows([]);
        }
      } finally {
        if (!isCancelled) {
          setLoading(false);
        }
      }
    };

    void loadRows();

    return () => {
      isCancelled = true;
    };
  }, []);

  return (
    <>
      <div style={{ marginBottom: 12 }}>
        <h1 style={{ margin: 0 }}>Escalated Items</h1>
      </div>
      {loading ? (
        <Box sx={{ color: "#4b5563", fontSize: 14, mb: 1 }}>
          <Typography variant="body2" component="span">
            Loading escalated items data...
          </Typography>
        </Box>
      ) : null}
      <DCCostBatchDetail
        batchIdOverride={batchIdOverride}
        exportFileNameOverride="escalated items exports.xlsx"
        frozenColumnsOverride={[
          { field: "parsedSku", headerName: "parsedSku", width: 120 },
          { field: "batchId", headerName: "batchId", width: 110 },
          { field: "hqLine", headerName: "hqLine", width: 90 },
        ]}
        detailRowsOverride={rows}
        rowActionsOverride={[]}
        hideHeader
        hideDescription
        hideBulkActions
        showExportButton
        hideEmptyStateMessage
        titleOverride="Escalated Items"
      />
    </>
  );
};

export default DCEscalationReviews;
